import type Medusa from "@medusajs/js-sdk";
import type { Meilisearch } from "meilisearch";

export async function getProductByHandle({
    client,
    searchClient,
    handle,
    salesChannelId,
}: {
    client: Medusa;
    searchClient: Meilisearch;
    handle: string;
    salesChannelId: string;
}) {
    const { hits } = await searchClient.index("cards").search<{
        id: string;
        product_id?: string | null;
    }>(null, {
        filter: `handle = ${JSON.stringify(handle)}`,
        attributesToRetrieve: ["id", "product_id"],
        limit: 1,
    });
    const productId = hits[0]?.product_id || hits[0]?.id;
    if (!productId) return undefined;

    return Promise.all([
        client.store.product.retrieve(productId, {
            fields: "title,handle,description,variants.*,thumbnail,images.url,images.metadata,external_id,categories.*,metadata,options.*,options.values.*,variants.options.*,+variants.calculated_price,+product_display_tags.*",
            country_code: "ru",
        }),
        client.store.product.list({
            id: productId,
            sales_channel_id: salesChannelId,
            fields: "variants.id,variants.manage_inventory,variants.inventory_quantity",
            country_code: "ru",
        }),
    ]);
}
